interface CompanyInfoSources {
  udyamData?: any;
  gstData?: any;
  cinData?: any;
}

export class CompanyInfoParser {
  private udyamData?: any;
  private gstData?: any;
  private cinData?: any;

  // Overloads
  constructor();
  constructor(data: CompanyInfoSources);
  constructor(data?: CompanyInfoSources) {
    this.udyamData = data?.udyamData;
    this.gstData = data?.gstData;
    this.cinData = data?.cinData;
  }

  setData(data: CompanyInfoSources) {
    if (data.udyamData) this.udyamData = data.udyamData;
    if (data.gstData) this.gstData = data.gstData;
    if (data.cinData) this.cinData = data.cinData;
  }

  getDateOfIncorporation(): string | undefined {
    return (
      this.cinData?.company_data?.date_of_incorporation ||
      this.udyamData?.["Date of Incorporation"] ||
      // this.gstData?.details?.rgdt ||
      "Na"
    );
  }

  getCompanyName(): string | undefined {
    return (
      this.cinData?.company_data?.company_name ||
      this.udyamData?.["Name of Enterprise"] ||
      this.gstData?.corporate_name ||
      "Na"
    );
  }

  getRegisteredAddress(): string | undefined {
    return (
      this.cinData?.company_data?.registered_address ||
      (this.gstData?.details?.pradr?.addr &&
        [
          this.gstData.details.pradr.addr.flno,
          this.gstData.details.pradr.addr.bnm,
          this.gstData.details.pradr.addr.st,
          this.gstData.details.pradr.addr.loc,
          this.gstData.details.pradr.addr.stcd,
          this.gstData.details.pradr.addr.pncd,
        ]
          .filter(Boolean)
          .join(", ")) ||
      (this.udyamData?.["Unit(s) Details"]?.[0] &&
        [
          this.udyamData["Unit(s) Details"][0].Flat,
          this.udyamData["Unit(s) Details"][0].Building,
          this.udyamData["Unit(s) Details"][0].City,
          this.udyamData["Unit(s) Details"][0].State,
          `Pin: ${this.udyamData["Unit(s) Details"][0].Pin}`,
        ]
          .filter(Boolean)
          .join(", ")) ||
      "Na"
    );
  }

  getRegisteredPlace(): string | undefined {
    return (
      this.cinData?.company_data?.registered_address ||
      this?.udyamData?.["Unit(s) Details"]?.[0]?.City ||
      this.gstData?.details?.pradr?.addr?.loc ||
      "Na"
    );
  }

  getBusinessNature(): string | undefined {
    const rawDivision =
      this.cinData?.company_data?.description_of_main_division;
    const cleanedDivision = rawDivision
      ?.split(";")
      ?.find((part: any) => part?.toLowerCase()?.includes("consultancy"));

    const formattedDivision = cleanedDivision
      ?.replace(/([a-z])([A-Z])/g, "$1 $2") // add space only between lowercase-uppercase
      ?.replace(/\s+/g, " ")
      ?.trim()
      ?.toLowerCase()
      ?.replace(/\b\w/g, (c: any) => c.toUpperCase());
    return formattedDivision || this.gstData?.details?.pradr?.ntr || "Na";
  }
  getEntityType(): string | undefined {
    const data = this.cinData?.company_data;
    if (data) {
      const cls = data.class_of_company?.toLowerCase();
      const cat = data.company_category?.toLowerCase();
      const subCat = data.company_subcategory?.toLowerCase();
      if (cls === "private" && cat?.includes("shares")) {
        return "Private Limited Company";
      } else if (cls === "public" && cat?.includes("shares")) {
        return "Public Limited Company";
      } else if (cat?.includes("guarantee")) {
        return "Company Limited by Guarantee";
      } else if (cat?.includes("unlimited")) {
        return "Unlimited Company";
      } else if (subCat?.includes("government")) {
        return "Government Company";
      }
      return "Company";
    }
    return (
      this.gstData?.details?.ctb ||
      this.udyamData?.["Organisation Type"] ||
      "NA"
    );
  }

  getDirectors(): string[] {
    return this.cinData?.company_directors?.map((dir: any) => dir.name) || [];
  }

  getGSTIN(): string | undefined {
    return this.gstData?.gstin || "Na";
  }

  getEmail(): string | undefined {
    return (
      this.cinData?.company_data?.email_id || this.udyamData?.Email || "Na"
    );
  }

  getMobile(): string | undefined {
    return this.udyamData?.Mobile || "Na";
  }

  getUdyamRegistrationDate(): string | undefined {
    return this.udyamData?.["Date of Udyam Registration"] || "Na";
  }
}
